// extracted by mini-css-extract-plugin
module.exports = {"cart__wrapp":"b_b"};